import * as miscellaneousActionType from '../actionsType/miscellaneous.actionType';

export const initialState = {
    cardHt: 207,
    withBlockCardHt: 207,
    cardId: 0,
    tab: 'CONTENT',
    brWidth: 0,
    expandRequestObject: null,
    lexRequestObject: null,
    cardExpand: false,
    lpDataForCourseLaunch: null
};

export function miscellaneousReducer(state = initialState, action) {
    switch (action.type) {
        case miscellaneousActionType.SET_LEX_CARD_HT:
            return {...state, cardHt: action.payload};
        case miscellaneousActionType.SET_LEX_CARD_BL_HT:
            return {...state, withBlockCardHt: action.payload};
        case miscellaneousActionType.SET_LEX_CARD_ID:
            return {...state, cardId: action.payload};
        case miscellaneousActionType.SET_LEX_TAB:
            return {...state, tab: action.payload};
        case miscellaneousActionType.SET_BR_DIMENSION:
            return {...state, brWidth: action.payload};
        case miscellaneousActionType.SET_LEX_EXPAND_REQ_OBJ:
            return {...state, expandRequestObject: action.payload};
        case miscellaneousActionType.SET_EXPAND_REQ_OBJ:
            return {...state, lexRequestObject: action.payload};
        case miscellaneousActionType.SET_LEX_EXP_CARD:
            return {...state, cardExpand: action.payload};
        case miscellaneousActionType.SET_LP_DATA_FOR_CORUSE_LAUNCH:
            return {...state, lpDataForCourseLaunch: action.payload};
        default:
            return state;
    }
}
